import { button } from "./button";
import { guideStepCheck } from "./guideStepCheck";
export function guideStepCompleation(json, currentStep) {
  let isCompleted = currentStep.isCompleted;
  let hideLink = json.properties.hideActionLinkAfterStep;

  const guideStepCompleation = `
    ${json.properties.actionLink && json.properties.actionLink.length > 0 ? (!isCompleted || (isCompleted && !hideLink) ? button(json.properties.actionLink[0], "actionlink") : ``) : json.properties.actionLinkText != "" ? guideStepCheck(json.properties.actionLinkText, currentStep) : ``}          
    ${json.properties.actionLink && json.properties.actionLink.length > 0 && json.properties.requiredActionButton && json.properties.actionLinkText != "" ? guideStepCheck(json.properties.actionLinkText, currentStep, isCompleted ? `` : `hidden`) : ``} 
  `;
  return guideStepCompleation;
}
